import { DataQueryKey, UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import { QUERY_KEY_TO_PERSIST } from '../../../modules/offline/queryClient/offlineQueryClient';

export const getFindBrandGeneralSettingsKey = (): UseDataQuery['queryKey'] => [
  DataQueryKey.BRAND_GENERAL_SETTINGS,
  undefined,
  QUERY_KEY_TO_PERSIST,
];
